import React from 'react';
import { TableHeaderColumn } from 'react-bootstrap-table';
import Grid from '../../../../Utils/Grid';

const ListadoAnnual = (props) => {
    const { data, loader, onSortChange  } = props;
    
    if (!data || !data.years){
        return <div>No hay datos disponibles</div>;
    }

    const formatearNumero = (dato) => {
        const formatoMoneda = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
        const numero = Number(dato);
        return formatoMoneda.format(numero).replace('$', '$ ');
    };
    const columnaClaseTotal = (cell, row) => {
        if (row.name === 'Total') {
            return 'celda-totales';
        }
        return '';
    };

    const columnas = data.years.map((year, index) => (
        <TableHeaderColumn
            key={index}
            dataField={year}
            dataSort
            dataFormat={formatearNumero}
            columnClassName={columnaClaseTotal}
            width='130'
            dataAlign='right'
            headerAlign='right'
        >
            {year}
        </TableHeaderColumn>
    ));
    
    return (
        <div>
            <Grid
                hover
                striped
                data={!data || !Array.isArray(data.results) ? [] : data }
                loading={loader}
                onSortChange={onSortChange}
                pagination={false}
                className="pb-3"
            >
                <TableHeaderColumn
                    dataField="name"
                    dataSort
                    isKey
                    columnClassName={columnaClaseTotal}
                    width='200'
                >
                    RUBRO
                </TableHeaderColumn>
                {columnas}
            </Grid>
            <br />
        </div>
    )
};

export default ListadoAnnual;
